<template>
  <div>
    <div class="filters-banner d-flex align-items-center justify-content-between">
      <div class="filters-left d-flex align-items-center" style="margin-top: 1%;">
        <b-form-select v-model="filters.year" :options="optionsCache.years" class="filter-item mr-2" placeholder="Year"
          @change="fetchServices(1)" />
        <b-form-select v-model="filters.city" :options="optionsCache.cities" class="filter-item mr-2" placeholder="City"
          @change="fetchServices(1)" />
        <b-form-select v-model="filters.item" :options="optionsCache.items" class="filter-item mr-2" placeholder="Item"
          @change="fetchServices(1)" />
        <b-form-select v-model="filters.category" :options="optionsCache.categories" class="filter-item mr-2"
          placeholder="Category" @change="fetchServices(1)" />
        <b-form-select v-model="filters.supplier" :options="optionsCache.suppliers" class="filter-item mr-2"
          placeholder="Supplier" @change="fetchServices(1)" />
        <h5 class="service-count mb-0 mr-2">Services ({{ pagination.total }})</h5>
        <b-form-input v-model="searchQuery" class="filter-item search-bar mr-2" placeholder="Search..."
          @input="fetchServices(1)" />
        <b-button variant="secondary" @click="resetFilters" class="filter-item reset-btn mr-2">Reset</b-button>
        <b-button variant="primary" @click="showForm = true; currentService = null" class="filter-item add-service-btn">
          Add Service
        </b-button>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table table-striped custom-table">
        <thead class="thead-dark">
          <tr>
            <th><input type="checkbox" @change="selectAll" /></th>
            <th @click="sortBy('id')">
              Id <span v-if="sortColumn === 'id'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
            </th>
            <th @click="sortBy('item')">
              Item <span v-if="sortColumn === 'item'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
            </th>
            <th @click="sortBy('year')">
              Year <span v-if="sortColumn === 'year'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
            </th>
            <th>City</th>
            <th>Adult Price (Gross)</th>
            <th>Adult Price (Net)</th>
            <th>Price (Gross)</th>
            <th>Type</th>
            <th>Tax</th>
            <th>Tax Rate</th>
            <th>Category</th>
            <th>Remarks</th>
            <th>Cancellation</th>
            <th>Supplier</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="service in services" :key="service.id" @contextmenu.prevent="showContextMenu($event, service)"
            @click="toggleRowSelection(service.id)" :class="{ 'highlight': service.isSelected }"
            @mouseenter="highlightRow(service, true)" @mouseleave="highlightRow(service, false)">
            <td><input type="checkbox" v-model="selectedServices" :value="service.id" /></td>
            <td>{{ service.id }}</td>
            <td>{{ service.attributes.item }}</td>
            <td>{{ service.attributes.year }}</td>
            <td>
              <ul>
                <li v-for="city in service.attributes.cities.data" :key="city.id">
                  {{ city.attributes.city }}
                </li>
              </ul>
            </td>
            <td>{{ formatPrice(service.attributes.adultPrice_gross, serviceCity(service)) }}</td>
            <td>{{ formatPrice(service.attributes.adultPrice_net, serviceCity(service)) }}</td>
            <td>{{ formatPrice(service.attributes.price, serviceCity(service)) }}</td>
            <td>{{ service.attributes.type }}</td>
            <td>{{ service.attributes.tax }}</td>
            <td>{{ service.attributes.rate }}%</td>
            <td>{{ service.attributes.category }}</td>
            <td>{{ service.attributes.remarks }}</td>
            <td>{{ service.attributes.cancellation }}</td>
            <td>{{ service.attributes.supplier }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div class="mt-3 d-flex justify-content-center">
      <b-pagination v-model="pagination.currentPage" :total-rows="pagination.total" :per-page="pagination.perPage"
        @change="fetchServices" aria-controls="service-table"></b-pagination>
    </div>

    <!-- Context Menu -->
    <div v-if="contextMenuVisible" :style="{ top: `${contextMenuPosition.y}px`, left: `${contextMenuPosition.x}px` }"
      class="context-menu">
      <ul>
        <li @click="editService(contextMenuService)">Edit</li>
        <li @click="confirmDelete(contextMenuService)">Delete</li>
        <li @click="promptCloneService(contextMenuService)">Clone</li>
        <li @click="exportSelectedServices">Export</li>
      </ul>
    </div>

    <ServiceFormRiver v-if="showForm" :service="currentService" :cities="cities"
      @close="showForm = false; currentService = null" @service-added="fetchServices" />

    <!-- Clone Service Modal -->
    <b-modal v-model="showCloneModal" title="Clone Service" @ok="cloneService">
      <b-form-row class="align-items-center">
        <b-col class="col-8">
          <b-form-group label="Item:" label-for="item-input" class="mb-0">
            <b-form-input id="item-input" v-model="cloneItem" type="text" placeholder="Enter item name" class="w-100" />
          </b-form-group>
        </b-col>

        <b-col class="col-4">
          <b-form-group label="Year:" label-for="year-input" class="mb-0">
            <b-form-input id="year-input" v-model="newYear" type="number" placeholder="Enter year" class="w-100" />
          </b-form-group>
        </b-col>
      </b-form-row>
    </b-modal>

    <!-- Delete Confirmation Modal -->
    <b-modal v-model="showDeleteModal" title="Confirm Deletion" @ok="deleteSelectedServices">
      <p>Are you sure you want to delete the selected service(s)? This action cannot be undone.</p>
    </b-modal>

    <!-- Toast Notifications -->
    <b-toast id="success-toast" title="Success" variant="success" solid>Service cloned successfully!</b-toast>
    <b-toast id="error-toast" title="Error" variant="danger" solid>Failed to clone service. Please try again.</b-toast>
    <b-toast v-model="toastVisible" id="feedback-toast" :title="toastTitle" :variant="toastVariant" solid>{{
      toastMessage }}</b-toast>
  </div>
</template>



<script>
import ServiceFormRiver from './ServiceFormRiver.vue';
import { formatPrice } from '../Helper/PriceDisplay.js';
import { exportSelectedServices } from '../Helper/GenerateServiceexcelriver.js';
import qs from 'qs';


export default {
  components: {
    ServiceFormRiver
  },
  data() {
    return {
      services: [],
      selectedServices: [],
      showForm: false,
      showCloneModal: false,
      currentService: null,
      newYear: '',
      cloneItem: '',
      toastVisible: false,
      toastTitle: '',
      toastMessage: '',
      toastVariant: '',
      optionsCache: {
        years: [],
        cities: [],
        items: [],
        suppliers: [],
        categories: []
      },
      pagination: {
        currentPage: 1,
        perPage: 25,
        total: 0
      },
      searchQuery: '',
      filters: {
        year: '',
        city: '',
        item: '',
        supplier: '',
        category: ''
      },
      cities: [],
      contextMenuVisible: false,
      contextMenuPosition: { x: 0, y: 0 },
      contextMenuService: null,
      sortColumn: 'id',
      sortDirection: 'desc',
    };
  },
  async created() {
    this.fetchOptions();
    await this.fetchServices();
    await this.fetchCities();
    this.loadFilters();
  },
  methods: {

    formatPrice,
    exportSelectedServices,

    async fetchServices(page = this.pagination.currentPage) {
      try {
        const queryParams = {
          populate: '*',
          sort: [`${this.sortColumn}:${this.sortDirection}`],
          pagination: {
            page: page,
            pageSize: this.pagination.perPage
          },
          filters: {}
        };

        if (this.filters.year) queryParams.filters.year = { $eq: this.filters.year };
        if (this.filters.city) queryParams.filters.cities = { city: { $eq: this.filters.city } };
        if (this.filters.item) queryParams.filters.item = { $containsi: this.filters.item };
        if (this.filters.supplier) queryParams.filters.supplier = { $containsi: this.filters.supplier };
        if (this.filters.category) queryParams.filters.category = { $eq: this.filters.category };

        if (this.searchQuery) {
          queryParams.filters.$or = [
            { item: { $containsi: this.searchQuery } },
            { supplier: { $containsi: this.searchQuery } },
            { remarks: { $containsi: this.searchQuery } }
          ];
        }

        const queryString = qs.stringify(queryParams, { encodeValuesOnly: true });
        const response = await this.$xhr.get(`/api/servicerivers?${queryString}`);

        this.services = response.data.data.map(service => ({
          ...service,
          attributes: {
            ...service.attributes,
            city: service.attributes.city || { data: { attributes: { city: 'Unknown' } } }
          },
          isSelected: false
        }));
        this.pagination.total = response.data.meta.pagination.total;
        this.pagination.currentPage = page;

      } catch (error) {
        console.error('Error fetching services:', error);
      }
    },
    async fetchOptions() {
      try {
        const response = await this.$xhr.get('/api/servicerivers/filters');
        const data = response.data;
        this.optionsCache.years = [{ value: '', text: 'Year' }, ...(data.years || []).map(y => ({ value: y, text: y }))];
        this.optionsCache.cities = [{ value: '', text: 'City' }, ...(data.cities || []).map(c => ({ value: c, text: c }))];
        this.optionsCache.items = [{ value: '', text: 'Item' }, ...(data.items || []).map(i => ({ value: i, text: i }))];
        this.optionsCache.suppliers = [{ value: '', text: 'Supplier' }, ...(data.suppliers || []).map(s => ({ value: s, text: s }))];
        this.optionsCache.categories = [{ value: '', text: 'Category' }, ...(data.categories || []).map(c => ({ value: c, text: c }))];
      } catch (error) {
        console.error('Error fetching options:', error);
      }
    },
    resetFilters() {
      this.filters = { year: '', city: '', item: '', supplier: '', category: '' };
      localStorage.removeItem('lastAppliedFilters');
      this.fetchServices(1);
    },
    saveFilters() {
      localStorage.setItem('lastAppliedFilters', JSON.stringify(this.filters));
    },
    loadFilters() {
      const savedFilters = localStorage.getItem('lastAppliedFilters');
      if (savedFilters) {
        this.filters = JSON.parse(savedFilters);
      }
    },

    async fetchCities() {
      const response = await this.$xhr.get('/api/cities?pagination[pageSize]=1000&sort[0]=city:asc');
      this.cities = response.data.data;
    },
    showContextMenu(event, service) {
      this.contextMenuVisible = true;
      this.contextMenuPosition = { x: event.clientX, y: event.clientY };
      this.contextMenuService = service;
    },
    hideContextMenu() {
      this.contextMenuVisible = false;
      this.contextMenuService = null;
    },
    editService(service) {
      this.hideContextMenu();
      this.currentService = service;
      this.showForm = true;
    },
    async confirmDelete() {
      // First, check if any of the selected services are in use in tours
      const inUseServices = await this.checkIfServicesInUseInTours(this.selectedServices);

      if (inUseServices.length > 0) {
        this.showToast('Abort Delete', `The item is currently in use in tours and cannot be deleted.`, 'danger');
      } else {
        this.showDeleteModal = true;
      }
    },

    async checkIfServicesInUseInTours(serviceIds) {
      const inUseServiceNames = [];
      for (const serviceId of serviceIds) {
        const response = await this.$xhr.get(`/api/tourrivers?populate=*`);
        const tours = response.data.data;
        tours.forEach(tour => {
          const itemIds = tour.attributes.item.data.map(item => item.id);
          if (itemIds.includes(serviceId)) {
            // Push the service name to the inUseServiceNames array if found
            const service = this.services.find(s => s.id === serviceId);
            if (service) {
              inUseServiceNames.push(service.attributes.item);
            }
          }
        });
      }

      return inUseServiceNames;
    },

    async deleteSelectedServices() {
      await Promise.all(
        this.selectedServices.map(serviceId => this.$xhr.delete(`/api/servicerivers/${serviceId}`))
      );
      this.fetchServices();
      this.selectedServices = [];
      this.showDeleteModal = false;
      this.showToast('Success', 'Item deleted successfully!', 'success');
    },
    showToast(title, message, variant) {
      this.toastTitle = title;
      this.toastMessage = message;
      this.toastVariant = variant;
      this.toastVisible = true;
    },
    promptCloneService(service) {
      this.hideContextMenu();
      this.currentService = service;
      this.cloneItem = service.attributes.item; // Prefill the item field
      this.newYear = service.attributes.year; // Prefill year
      this.showCloneModal = true;
    },
    closeCloneModal() {
      this.showCloneModal = false;
      this.newYear = '';
      this.cloneItem = '';
    },
    async cloneService() {
      if (this.newYear && this.cloneItem) {
        const newYear = String(this.newYear);
        const cloneItem = this.cloneItem;

        try {
          // Check for existing service
          const existingServiceResponse = await this.$xhr.get(`/api/servicerivers?filters[item][$eq]=${encodeURIComponent(cloneItem)}&filters[year][$eq]=${encodeURIComponent(newYear)}`);

          if (existingServiceResponse.data.data.length > 0) {
            this.$bvToast.toast('This service already exists for the specified year.', {
              title: 'Clone Aborted',
              variant: 'danger',
              solid: true,
            });
            return;
          }

          // Prepare cloned service data
          const clonedService = { ...this.currentService };
          clonedService.attributes.year = newYear;
          clonedService.attributes.item = cloneItem;
          clonedService.id = null; // Ensure the cloned service gets a new ID

          // Include cities in the cloned service
          const cityIds = this.currentService.attributes.cities?.data.map(city => city.id) || [];
          const requestData = {
            data: {
              ...clonedService.attributes,
              cities: cityIds.length > 0 ? cityIds.map(id => ({ id })) : undefined,
            },
          };

          // Post the cloned service
          await this.$xhr.post('/api/servicerivers', requestData);
          this.fetchServices();
          this.closeCloneModal();
          this.$bvToast.toast('Service cloned successfully!', {
            title: 'Success',
            variant: 'success',
            solid: true,
          });
        } catch (error) {
          console.error('Error cloning service:', error);
          this.$bvToast.toast('An error occurred while cloning the service.', {
            title: 'Error',
            variant: 'danger',
            solid: true,
          });
        }
      } else {
        this.$bvToast.toast('Please enter both item name and a new year.', {
          title: 'Warning',
          variant: 'warning',
          solid: true,
        });
      }
    },
    selectAll(event) {
      this.selectedServices = event.target.checked ? this.services.map(service => service.id) : [];
    },
    toggleRowSelection(serviceId) {
      const index = this.selectedServices.indexOf(serviceId);
      if (index === -1) {
        this.selectedServices.push(serviceId);
      } else {
        this.selectedServices.splice(index, 1);
      }
    },
    highlightRow(service, isHovered) {
      service.isSelected = isHovered;
    },
    serviceCity(service) {
      const cities = service.attributes.cities?.data;
      if (!cities || cities.length === 0) return null;
      const prague = cities.find(c => c.attributes.city === 'Prague');
      return prague ? 'Prague' : cities[0].attributes.city;
    },
    sortBy(column) {
      if (this.sortColumn === column) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        // Set new column and reset direction
        this.sortColumn = column;
        this.sortDirection = 'asc';
      }
    }
  },
  mounted() {
    document.addEventListener('click', this.hideContextMenu);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.hideContextMenu);
  },
  watch: {
    filters: {
      handler() {
        this.saveFilters();
      },
      deep: true
    }
  },
};
</script>
<style scoped>
.filters-banner {
  background-color: #f8f9fa;
  padding: 10px 20px;
  border-radius: 8px;
  display: flex;
  align-items: center;
}

.filters-left {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.service-length-center {
  flex-grow: 1;
  display: flex;
  justify-content: center;
  text-align: center;
}

.filters-right {
  display: flex;
  align-items: center;
  gap: 10px;
}

.filter-item {
  min-width: 160px;
  max-width: 160px;
}

.search-bar {
  max-width: 300px;
}

.reset-btn,
.add-service-btn {
  min-width: 120px;
}

.service-count {
  font-weight: bold;
}

.custom-table {
  max-height: 65vh;
  overflow-y: auto;
  display: block;
}

.table-responsive {
  overflow-y: auto;
}

.table th,
.table td {
  text-align: center;
  width: 6%;
}

.table th:last-child,
.table td:last-child {
  width: 40%;
}

.table .thead-dark th {
  position: sticky;
  top: 0;
  z-index: 1;
  color: orange;
}

.nested-table {
  width: 100%;
  border-collapse: collapse;
}

.nested-table th,
.nested-table td {
  padding: 2px;
  border: 1px solid #ddd;
}

.nested-table th {
  width: 40%;
}

.success-box {
  background-color: #d4edda;
  border: 1px solid #c3e6cb;
  padding: 10px;
}

.danger-box {
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
  padding: 10px;
}

.service-row:hover {
  background-color: #edc99b;
}

.context-menu {
  position: fixed;
  background-color: #e6e0e0;
  border: 1px solid #ddd;
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);
  width: 150px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 5px 0;
}

.context-menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
}

.context-menu li {
  padding: 10px;
  cursor: pointer;
  text-align: center;
}

.context-menu li:hover {
  background-color: #edc99b;
}

.align-items-center {
  align-items: center;
}
</style>